import React from 'react';
import { graphql } from 'gatsby';
import PageContent from '../components/organisms/PageContent';

const IndexPage = ( { data } ) => <PageContent data={data.contentfulPage}/>;

export default IndexPage;

export const frontPageQuery = graphql`
    query {
        contentfulPage(slug: {eq: "home"}) {
            slug
            title
            heroImage {
                fluid {
                    ...GatsbyContentfulFluid_withWebp_noBase64
                }
            }
            optionalVideo {
              file {
                url
              }
            }
            modules {
                id
                title
                column1 {
                    raw
                    references {
                        ... on ContentfulAsset {
                            # contentful_id is required to resolve the references
                            contentful_id
                            __typename
                            fluid {
                                ...GatsbyContentfulFluid_withWebp_noBase64
                            }
                        }
                    }
                }
                column2 {
                    raw
                    references {
                        ... on ContentfulAsset {
                            # contentful_id is required to resolve the references
                            contentful_id
                            __typename
                            fluid {
                                ...GatsbyContentfulFluid_withWebp_noBase64
                            }
                        }
                    }
                }
                backgroundColour
                cta {
                    text
                    url
                    column
                }
                badge {
                    text
                    leftPos
                    topPos
                    column
                }
                gridColumns {
                    col1Width
                    col2Width
                }
                hasPadding
            }
        }
    }
`;
